import { render, staticRenderFns } from "./PejuangOnlineBanner.vue?vue&type=template&id=08afc174&"
import script from "./PejuangOnlineBanner.vue?vue&type=script&lang=js&"
export * from "./PejuangOnlineBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports